import React, { Suspense, useEffect, useState } from 'react';
import { MemoryRouter, Switch, Route, Redirect } from 'react-router-dom';

import { NEARMECHECK_ROUTES } from 'src/routes';
import {
    getInitialWidgetRoute,
    scrubWidgetRouteFromUrl,
} from 'src/shared/helpers/widget-route-in-url';

import { AuthorizationProvider } from './shared/contexts/authorization';
import { SpinnerFullPage } from './near-me-check/components/spinner';
import { NearMeCheckProvider } from './shared/contexts/near-me-check-context';
import { nearMeCheckRoutes } from './near-me-check/router';

export function AppRouter() {
    // Seeded once on mount: after the Google OAuth redirect the widget route (with the
    // accountToken) lives in the URL hash, which MemoryRouter doesn't read on its own.
    const [initialRoute] = useState(getInitialWidgetRoute);

    useEffect(() => {
        scrubWidgetRouteFromUrl();
    }, []);

    return (
        <MemoryRouter initialEntries={[initialRoute]}>
            <Suspense fallback={<SpinnerFullPage />}>
                <AuthorizationProvider>
                    <NearMeCheckProvider>
                        <Switch>
                            {nearMeCheckRoutes.map((route) => {
                                return (
                                    <Route exact path={route.path} key={route.path}>
                                        {route.component}
                                    </Route>
                                );
                            })}

                            {/*  DEFAULT ROUTE */}
                            <Route>
                                <Redirect to={NEARMECHECK_ROUTES.START} />
                            </Route>
                        </Switch>
                    </NearMeCheckProvider>
                </AuthorizationProvider>
            </Suspense>
        </MemoryRouter>
    );
}
